const config = {
  development: {
    BASE_URL: `https://localhost:5000/`,
  },
  test: {
    BASE_URL: `http://localhost`,
  },
  production: {
    BASE_URL: process.env.REACT_APP_PRODUCTION_BACKEND_HOST,
  },
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIRE_BASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/common/environmentConfig.js